import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Распределение деталей лекала по группам (тканям) перетаскиванием.
// После каждого дропа шлём снимок всех групп целиком — сервер не гадает, что
// именно переехало, и заодно фиксирует порядок деталей внутри группы.
export default class extends Controller {
  static values = { url: String }
  static targets = ["list", "status", "count"]

  connect() {
    this.sortables = this.listTargets.map(list => Sortable.create(list, {
      group: "lekalo-pieces",
      animation: 150,
      ghostClass: "opacity-40",
      onEnd: () => this.save()
    }))
  }

  disconnect() {
    this.sortables?.forEach(s => s.destroy())
  }

  async save() {
    this.refreshCounts()
    this.setStatus("Сохраняю…")
    const groups = {}
    this.listTargets.forEach(list => {
      groups[list.dataset.groupId] = Array.from(list.querySelectorAll("[data-piece-id]"))
        .map(el => el.dataset.pieceId)
    })
    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        body: JSON.stringify({ groups })
      })
      this.setStatus(response.ok ? "Сохранено" : "Не сохранилось — обновите страницу")
    } catch {
      this.setStatus("Не сохранилось — обновите страницу")
    }
  }

  // Счётчик «деталей: N» в шапке группы — иначе после переноса он врёт до перезагрузки.
  refreshCounts() {
    this.countTargets.forEach(el => {
      const list = this.listTargets.find(l => l.dataset.groupId === el.dataset.groupId)
      if (list) el.textContent = list.querySelectorAll("[data-piece-id]").length
    })
  }

  setStatus(text) {
    if (!this.hasStatusTarget) return
    this.statusTarget.textContent = text
    clearTimeout(this.statusTimer)
    this.statusTimer = setTimeout(() => { this.statusTarget.textContent = "" }, 2500)
  }
}
